import { Controller } from "@hotwired/stimulus"

// Sets the hidden `effective_date` input on the end-series form based on the
// chosen radio option:
//   - "today"      → today's date
//   - "after_next" → the day after the series' next scheduled occurrence
//   - "specific"   → whatever is in the specific_date input
export default class extends Controller {
  static values = { nextOccurrenceDate: String }

  beforeSubmit() {
    const choice = this.element.querySelector('input[name="effective_choice"]:checked')?.value
    let date

    if (choice === "after_next" && this.nextOccurrenceDateValue) {
      date = new Date(this.nextOccurrenceDateValue)
      date.setDate(date.getDate() + 1)
    } else if (choice === "specific") {
      const specific = this.element.querySelector('input[name="specific_date"]').value
      date = specific ? new Date(specific) : new Date()
    } else {
      date = new Date()
    }

    const iso = date.toISOString().slice(0, 10)
    this.element.querySelector('input[name="effective_date"]').value = iso
  }
}
